import moment from 'moment';

export const formatRelativeDate = (dateString: string): { text: string; isStale: boolean } => {
  const date = moment.utc(dateString).local(); // convert from UTC to local
  const now = moment();

  const diffInMinutes = now.diff(date, 'minutes');
  const diffInMonths = now.diff(date, 'months');

  if (diffInMonths >= 1) {
    return {
      text: date.format('L'), // fallback: "MM/DD/YYYY"
      isStale: true,
    };
  }

  return {
    text: date.fromNow(), // e.g., "5 minutes ago"
    isStale: diffInMinutes < 10, // flag if older than 10 minutes
  };
};

export const formatFullDate = (dateString: string, includeTime: boolean): string => {
  const date = moment.utc(dateString).local();
  return includeTime ? date.format('D MMMM YYYY, hh:mm A') : date.format('D MMMM YYYY');
};

export const generateInvoiceNumber = (): string => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-based
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const min = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');

  return `INV-${yyyy}${mm}${dd}-${hh}${min}${ss}`;
};
